'use client';

import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Breadcrumbs from '@/components/Breadcrumbs';
import ACElement1 from '@/components/ACElement1';
import FAQSection from '@/components/FAQSection';
import { airCleanerFaqs } from '@/data/faqData';

const AirCleanerPage = () => {
  return (
    <>
      <Header />
      <div className="header-gap-creator"></div>
      <main>
        <Breadcrumbs items={[{ label: 'Air Cleaner Assemblies' }]} />
          <ACElement1 />
          <FAQSection faqs={airCleanerFaqs} title="FAQs About Air Cleaner Assemblies" />
      </main>
      <Footer />
    </>
  );
};

export default AirCleanerPage;
